export default function getLinkTargetUrl(node, location=window.location) {
    const href = node.getAttribute('href');
    const origin = `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;

    if (href && !href.match(/^http/)) {
        return `${origin}${href}`;
    }

    return href;
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/dom/getLinkTargetUrl.js